import React from 'react';
import { graphql } from 'gatsby';
import ShareBar from 'components/share/shareBar';

interface Props {
  text?: string;
}

export const ShareButtons: React.FC<Props> = (props) => {
  return <ShareBar text={props.text} />;
};

export const query = graphql`
  fragment ShareButtonsBlock on WpAcfSharebuttonsBlock {
    AcfShareButtons {
      text
    }
  }
`;
